export default "__VITE_ASSET__z5nAk0Ih__"